import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {httpUpdateUser, HttpUpdateUserOptions, HttpUpdateUserPayload} from '@/features/users/http/users.http'
import {MUTATION_KEYS} from '@/queryClient'
import {AxiosError} from 'axios'
import {UserExtended} from '@/features/users/types'
import {parseAxiosPromise} from '@/axiosInstance'
import {captureException} from '@sentry/react'

export const useUpdateUser = ({
    urlParams,
    options
}: {
    urlParams: HttpUpdateUserOptions['urlParams']
    params: HttpUpdateUserOptions['params']
    options?: UseMutationOptions<
        UserExtended,
        AxiosError<{errors: {field: string; rule: string}[]}>,
        HttpUpdateUserPayload
    >
}) => {
    return useMutation({
        ...options,
        mutationKey: [MUTATION_KEYS.UPDATE_USER],
        mutationFn: payload =>
            parseAxiosPromise({
                axiosPromise: httpUpdateUser({
                    urlParams,
                    params: {responseType: 'extended'},
                    payload
                }),
                onZodError: captureException,
                responseShape: UserExtended
            })
    })
}
